import React from 'react'
import PageHeader from '../../../componentsII/PageHeader'
import PageHeader2 from '../../../componentsII/PageHeader2'

const ISSBGHGMetricReport = () => {
  return (
    <div>
      <PageHeader2
        title="ISSB GHG Metric Report"
        text={[
          "View and export your scope1,scope2 and scope3 metrics in an easy to use report",
          "aligned to the International Sustainability Standards Board (ISSB)."
        ]}
        buttonTitle="Add ISSB GHG Metric Report"
        handleClick={() => {}}
        comingSoon={true}
        comingSoonText="Send me More Information"
      >
      </PageHeader2>
    </div>
  )
}

export default ISSBGHGMetricReport
